import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { Activity } from '../../types/ActivityTypes';
import ActivityForm from '../../components/ActivityForm';
import { createUpdateActivity, deleteActivity, downloadFormatActivities, exportActivities, getActivities, importActivities } from '../../api/activityApi';
import ActivityTable from '../../components/ActivityTable';
import ModalComponent from '../../components/ErrorsModal';
import { ShowModalProps } from '../../types/projectTypes';
import { useSnackbar } from '../../contexts/SnackbarContext';


const Activities: React.FC = () => {
  const [activities, setActivities] = useState<Activity[]>([]);

  const [showModal, setShowModal] = useState<ShowModalProps>({ show: false, message: "" });
  const [mostrarModal, setMostrarModal] = useState(false);
  const [mensajeError, setMensajeError] = useState('');
  const { showMessage } = useSnackbar();
  const mostrarError = (mensaje: string) => {
      setMensajeError(mensaje);
      setMostrarModal(true);
  };
  const cerrarModal = () => {
      setMostrarModal(false);
      setMensajeError('');
  };

  useEffect(() => {
    fetchActivities();
  }, []);

  const fetchActivities = async () => {
    const fetchedActivities = await getActivities(); 
    setActivities(fetchedActivities);
  };

  const handleAddActivity = async (newActivity: Omit<Activity, 'id'>) => {
    const addedActivity = await createUpdateActivity(newActivity); 
    setActivities([...activities, addedActivity]); 
  };

  const handleUpdateActivity = async (updateActivity: Activity) => {
    await createUpdateActivity(updateActivity);
      setActivities(activities.map((activity) =>
        activity.id === updateActivity.id ? updateActivity : activity
      )
    );
  };

  const handleDeteleActivity = async (activityId: string) => {
    await deleteActivity(activityId);
    setActivities(activities.filter((activity) => activity.name !== activityId));
    fetchActivities();
  };

  const handleDownloadFormat = async () => {
    try {
      await downloadFormatActivities();
    } catch (error) {
      console.error('Error al descargar el formato:', error);
    }
  };

  const formatNotFoundMessage = (
    count: number | undefined,
    items: Activity[] | undefined,
    header: string
  ): string => {
    if (!items || items.length === 0) return header;

    const lines = items.map((a) => {
      const id = a.id != null ? `[ ID: ${a.id} | ` : `[ID: |`;
      const section = a.section ? ` Sección: ${a.section} | ` : "";
      const name = a.name ? ` Actividad: ${a.name} | ` : "";
      const subActivity = a.subActivity ? ` SubActividad: ${a.subActivity} | ` : "";
      const cip = a.cip ? ` CIP: ${a.cip} ]` : "]";
      return `• ${id}${section}${name}${subActivity}${cip}`;
    });

    const countLine = `${count ?? items.length} actividades no se encontraron en la base de datos y no fueron agregadas ni actualizadas: \n\n`;
    return `${header}\n\n${countLine}${lines.join("\n")}`;
  };

  const handleImportActivities = async (file: File) => {
    try {
      const result = await importActivities(file);

      // Caso 1: Todo correcto
      if (!result.notFoundActivities || result.notFoundActivities.length === 0) {
        showMessage("Actividades actualizadas correctamente.", "success");
      } 
      // Caso 2: Importación parcial
      else {
        const header = result.message || "Importación completada parcialmente.";
        const message = formatNotFoundMessage(
          result.notFoundCount,
          result.notFoundActivities,
          header
        );
        //showMessage(`La actividades fueron actualizadas de forma correcta, excepto: ${message}`,"info");
        showMessage(`${message}`,"info");
      }
    } catch (error: any) {
      showMessage(`Error al importar las actividades: ${error}`, "error")
    } finally {
      await fetchActivities();
    }
  };

  const handleExportActivities = async () => {
    try {
      await exportActivities();
    } catch (error) {
      console.error('Error al exportar las actividades:', error);
    }
  };
  
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>Actividades</Typography>
      <ActivityForm onAddActivity={handleAddActivity} />
      <Box sx={{ mt: 4 }}>
        <ActivityTable 
        activities = {activities} 
        onUpdateActivity = {handleUpdateActivity} 
        onDeleteActivity = {handleDeteleActivity}
        onDownloadFormat = {handleDownloadFormat}
        onImportActivities = {handleImportActivities}
        onExportActivities = {handleExportActivities}
        />
      </Box>

      <ModalComponent
        open={mostrarModal}
        onClose={cerrarModal}
        message={showModal.message}
      />
    </Box>
  );
}

export default Activities;
